import _classCallCheck from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _assertThisInitialized from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _inherits from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import _classPrivateFieldInitSpec from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/classPrivateFieldInitSpec.js";
import _classPrivateFieldGet from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/classPrivateFieldGet.js";
import _classPrivateFieldSet from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/classPrivateFieldSet.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.weak-map.js";
import "core-js/modules/web.dom-collections.iterator.js";
// Copyright 2017-2022 @polkadot/types-codec authors & contributors
// SPDX-License-Identifier: Apache-2.0
import { Tuple } from "../base/Tuple.js";
/**
 * @name Range
 * @description
 * Rust `Range<T>` representation
 */

var _rangeName = /*#__PURE__*/new WeakMap();

export var Range = /*#__PURE__*/function (_Tuple) {
  _inherits(Range, _Tuple);

  var _super = _createSuper(Range);

  function Range(registry, Type, value) {
    var _this;

    var _ref = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
        _ref$rangeName = _ref.rangeName,
        rangeName = _ref$rangeName === void 0 ? 'Range' : _ref$rangeName;

    _classCallCheck(this, Range);

    _this = _super.call(this, registry, [Type, Type], value);

    _classPrivateFieldInitSpec(_assertThisInitialized(_this), _rangeName, {
      writable: true,
      value: void 0
    });

    _classPrivateFieldSet(_assertThisInitialized(_this), _rangeName, rangeName);

    return _this;
  }

  _createClass(Range, [{
    key: "start",
    get:
    /**
     * @description Returns the starting range value
     */
    function get() {
      return this[0];
    }
    /**
     * @description Returns the ending range value
     */

  }, {
    key: "end",
    get: function get() {
      return this[1];
    }
    /**
     * @description Returns the base runtime type name for this instance
     */

  }, {
    key: "toRawType",
    value: function toRawType() {
      return "".concat(_classPrivateFieldGet(this, _rangeName), "<").concat(this.start.toRawType(), ">");
    }
  }], [{
    key: "with",
    value: function _with(Type) {
      return /*#__PURE__*/function (_Range) {
        _inherits(_class, _Range);

        var _super2 = _createSuper(_class);

        function _class(registry, value) {
          _classCallCheck(this, _class);

          return _super2.call(this, registry, Type, value);
        }

        return _createClass(_class);
      }(Range);
    }
  }]);

  return Range;
}(Tuple);